import Index from '@tunnel-components/@sharded/header/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/header/index.ts